<section class="signup-content">

  <div class="signup">

    <!-- Header -->
    <div class="signup__header animated fadeInDown">
      <div class="text-center">

        <a routerLink="/shop" class="float-start">
          <img class="signup__logo" src="/assets/images/logo-main.svg?v={{logoVersionNumber()}}" alt="Pet Wants">
        </a>

      </div>
    </div>

    <!-- Forms -->
    <div class="container">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-8 offset-lg-4 signup__body animated fadeInUp">

          <!-- Loading -->
          @if (isLoadingContent() || accountService.isLoading() || isWaitingResponse()) {
          <mat-progress-bar mode="indeterminate" value="accent"></mat-progress-bar>
          }

          <header class="text-center">
            <h1 class="h4-bold text-secondary-800 head-font">
              CREATE YOUR ACCOUNT
            </h1>
          </header>

          <!-- @if (isLoadedMarketingValidations() || isTryingToApplyCoupon()) { -->
          @if (signupPromotionInfo()?.code && signupPromotionInfo()?.name) {
          <div class="alert alert-success border-0 z-1020 fade show animated fadeInUp rounded-3"
            [class.animated]="!isTryingToApplyCoupon()" role="alert">
            <div class="d-flex justify-content-center align-items-center gap-3">

              @if (signupPromotionInfo()?.code && signupPromotionInfo()?.name) {
              <section
                class="d-flex flex-column flex-sm-column flex-md-row flex-lg-row  align-items-center gap-2 gap-sm-2 gap-md-3 gap-lg-3">
                <section class="d-flex align-items-center gap-2 justify-content-center">
                  <i class="fas fa-tag"></i>
                  <strong>Discount successfully applied!</strong>
                </section>
                <section class="d-flex align-items-center gap-2 justify-content-center">
                  <i class="fw-semibold">({{signupPromotionInfo().code}})</i>
                  {{signupPromotionInfo().name}}
                </section>
                <!-- <section class="d-flex justify-content-center align-items-center gap-1 link-color h7-bold"
                  (click)="clearSignupPromotionInfo()" ngbTooltip="Change Coupon Code">
                  <i class="fas fa-sync"></i>
                  <a href="javascript:void(0)" class="link-color">
                    Change Coupon
                  </a>
                </section> -->
              </section>
              } @else {
              <section
                class="d-flex flex-column flex-sm-column flex-md-row flex-lg-row  align-items-center gap-2 gap-sm-2 gap-md-3 gap-lg-3">
                <section class="d-flex align-items-center gap-2 justify-content-center">
                  <i class="fas fa-tag"></i>
                  <strong class="text-nowrap">Have a coupon? Apply it here:</strong>
                </section>
                <section class="d-flex align-items-center gap-3">
                  <input type="text" class="form-control form-control-sm" placeholder="Coupon Code" #signupCouponCode
                    (keyup.enter)="applySignupCoupon(signupCouponCode.value)">

                  <section class="d-flex justify-content-center align-items-center gap-1 link-color h7-bold"
                    (click)="applySignupCoupon(signupCouponCode.value)">
                    <i class="fas fa-check"></i>
                    <a href="javascript:void(0)" class="link-color">
                      Apply
                    </a>
                  </section>

                  @if (signupPromotionInfoFromLS()?.code && signupPromotionInfoFromLS()?.name) {
                  or

                  <section class="d-flex justify-content-center align-items-center gap-1 link-color h7-bold"
                    (click)="restoreSignupInfo()">
                    <i class="fas fa-times"></i>
                    <a href="javascript:void(0)" class="link-color">
                      Cancel
                    </a>
                  </section>

                  }
                </section>
              </section>
              }

            </div>
          </div>
          }

          <!-- The three verification screens stand in for the stepper: waiting
               for the inbox, verified somewhere else, or a dead link. -->
          @if (requiresEmailVerification) {
          <app-email-verification [email]="signupEmail" (resend)="resendVerificationEmail()"
            (changeEmail)="changeVerificationEmail()" />
          }

          @if (showVerifiedBanner() && stepper.selectedIndex === 1) {
          <div class="alert alert-success text-center" role="status">
            Your email has been verified. Carry on creating your account.
          </div>
          }

          <!-- Hidden, never destroyed: that is what makes "Change email" free,
               because step 1 still holds everything the customer typed. -->
          <mat-stepper linear labelPosition="bottom" #stepper
            [class.d-none]="verification.pending() || verification.verifiedInOtherTab()
            || verification.error() || verification.isVerifyingToken()">

            <!-- Delivery information -->
            <mat-step #firstStep [completed]="firstStep.completed" [editable]="false">

              <ng-template matStepLabel>
                Delivery Information
              </ng-template>

              <app-check-address-signup #checkAddressComponent [firstStep]="firstStep"
                (deliveryAddressChanged)="deliveryAddressInformation = $event"
                (selectedDayChanged)="deliverySelectedDay = $event"
                (selectedTimeWindowChanged)="deliverySelectedTimeWindow = $event"
                (emailChanged)="signupEmail = $event"
                (pickupInfoChanged)="pickupInfo = $event"
                (deliveryOptionChanged)="deliveryOptionSelected = $event" (onNextStep)="continue()">
              </app-check-address-signup>

              <footer class="d-flex gap-2 flex-wrap mt-3 justify-content-center text-secondary">
                <span class="h6-regular">Already have an account?</span>
                <span class="h6-bold cursor-pointer" [routerLink]="'/login'">Sign in now</span>
              </footer>

            </mat-step>

            <!-- Personal information -->
            <mat-step [completed]="formValidityPersonalInformation && firstStep.completed" [editable]="false">

              <ng-template matStepLabel>
                Personal Information
              </ng-template>

              <app-personal-information-signup [stepper]="matStepper()" [firstStep]="firstStep"
                [signupEmail]="signupEmail" #personalInformationComponent [creatingAccount]="shouldDisableCreateClientButton()"
                (formValidityChanged)="formValidityPersonalInformation = $event"
                (personalInformationChanged)="personalInformationData = $event" (onNextStep)="createNewClient()">
              </app-personal-information-signup>

              <!-- Guards POST /account. An anonymous explorer does not call it,
                   so their Continue is never held waiting on this. -->
              @if (!isAnonymousExplorer()) {
              <app-turnstile class="d-block mt-3" action="signup" (outToken)="turnstileToken.set($event)" />
              }

            </mat-step>

            <!-- Payment method information -->
            <mat-step [completed]="formValidityPaymentMethod && !isWaitingResponse()" [editable]="false"
              [stepControl]="paymentMethodStepControl">

              <ng-template matStepLabel>
                Payment Information
              </ng-template>

              <!-- Lazily instantiated (DEV-11124). A mat-step builds every step
                   up front, which had this step's Turnstile widget minting a
                   token on page load — long expired by the time anyone reached
                   it. matStepContent defers it to when the step opens. -->
              <ng-template matStepContent>
                <app-payment-method-signup (formValidityChanged)="formValidityPaymentMethod = $event"
                  (onNextStep)="navigateToWelcomePage()" [in_selectedMembership]="deliveryOptionSelected">
                </app-payment-method-signup>
              </ng-template>

            </mat-step>

          </mat-stepper>

        </div>
      </div>
    </div>

  </div>

</section>